import {
    ICadastroDeDirecionamento,
    IDirecionamentoPayload,
} from "../../../Interfaces/AssistenciaTecnica/CadastroDeDirecionamento/CadastroDeDirecionamentoInterface";
import {
    AtualizacaoCadastroDeDirecionamentoService,
    CadastroDeDirecionamentoService,
    DeleteCadastroDeDirecionamentoService,
    getCadastroDeDirecionamentoService,
    ListagemCadastroDeDirecionamentoService,
    ListarCategoriasAtendimentosFilhoService,
    ListarCategoriasAtendimentosPaiService,
    ListarClassesControlesDirecionamentoService,
} from "../../../Services/AssistenciaTecnica/CadastroDeDirecionamento/CadastroDeDirecionamentoService";
import { Controller } from "../../Controller";

export async function CadastroDeDirecionamentoController(
    requestBody: ICadastroDeDirecionamento
) {
    return Controller(CadastroDeDirecionamentoService(requestBody));
}

export async function getCadastroDeDirecionamentoController(ID_CUSTO: number) {
    return Controller(getCadastroDeDirecionamentoService(ID_CUSTO));
}

export async function ListagemCadastroDeDirecionamentoController(
    requestBody: IDirecionamentoPayload
) {
    return Controller(ListagemCadastroDeDirecionamentoService(requestBody));
}

export async function AtualizacaoCadastroDeDirecionamentoController(
    requestBody: Array<ICadastroDeDirecionamento>
) {
    return Controller(AtualizacaoCadastroDeDirecionamentoService(requestBody));
}

export async function DeleteCadastroDeDirecionamentoController(ID: number) {
    return Controller(DeleteCadastroDeDirecionamentoService(ID));
}
export async function ListarClassesControlesDirecionamentoController() {
    return Controller(ListarClassesControlesDirecionamentoService());
}

export async function ListarCategoriasAtendimentosPaiController() {
    return Controller(ListarCategoriasAtendimentosPaiService());
}
export async function ListarCategoriasAtendimentosFilhoController(
    idCategoriaPai: number
) {
    return Controller(ListarCategoriasAtendimentosFilhoService(idCategoriaPai));
}
